// 腾讯Im https://cloud.tencent.com/document/product/269/37416
// 发送图片、文件等消息需要腾讯云即时通信IM上传插件
import { StaticToast } from 'src/components/common';
import { timSdkLogout, timSdkReceiveMessage, timSdkGetGroupList, timSdkUpdateConfig, timSdkDataDynamicUpdate } from 'src/store/im/action';
import { timCustomData } from 'src/store/im/utils';
import { pushIMInquiryEndNoticeOrOther } from 'src/store/inquiry/action';
import TIMUploadPlugin from 'tim-upload-plugin';

class TIMSDKIM {
  public tim;
  public scrllBottom;
  public readyState = 0; // 0 、1、2、3 与websocket状态保持一致
  constructor() {
    import(/* webpackChunkName: "tim" */ 'tim-js-sdk-ws').then((tim) => {
      window.TIM = tim;
    });
  }
  init(data) {
    window.globalStore.dispatch(timSdkLogout());
    // 创建 SDK 实例，TIM.create() 方法对于同一个 SDKAppID 只会返回同一份实例
    this.tim = window.TIM.create({
      ...data,
    }); // SDK 实例通常用 tim 表示
    // 设置 SDK 日志输出级别，详细分级请参见
    this.tim.setLogLevel(0);
    // 注册腾讯云即时通信IM上传插件
    this.tim.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin });
    this.IMlisten(data);
  }
  login(options) {
    const { userID, userSig, groupId = '' } = options;
    window.globalStore.dispatch(timSdkUpdateConfig({ currentConversationID: groupId }));
    console.log('userID', userID);
    this.tim
      .login({
        userID,
        userSig,
      })
      .then((res) => {
        console.log(res, '～～～～～～～～～～～～～～`登录成功了吗？？##########');
      })
      .catch((error) => {
        console.log('～～～～～～～～～～～～～～`222登录出错吗？？##########', error);
        StaticToast.error('与医生建立聊天失败，请稍后再试');
        // alert('IM登录出错，请控制台查看日志');
      });
  }
  TIMInstance() {
    return this.tim;
  }

  IMlisten(options) {
    // 监听事件，例如：
    this.tim.on(window.TIM.EVENT.SDK_READY, (event) => {
      console.log('1、收到离线消息和会话列表同步完毕通知，接入侧可以调用 sendMessage 等需要鉴权的接口', event.name);
      return this.onReadyStateUpdate(event);
      // 收到离线消息和会话列表同步完毕通知，接入侧可以调用 sendMessage 等需要鉴权的接口
      // event.name - TIM.EVENT.SDK_READY
    });

    this.tim.on(window.TIM.EVENT.MESSAGE_RECEIVED, (event) => {
      console.log('2、收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面', event.data);
      // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
      // event.name - TIM.EVENT.MESSAGE_RECEIVED
      // event.data - 存储 Message 对象的数组 - [Message]

      // 推送了问诊结束消息
      if (event.name === 'onMessageReceived') {
        this.onWatchTimEndEvent(event.data);
        window.globalStore.dispatch(timSdkReceiveMessage(event, true));
      }
    });

    this.tim.on(window.TIM.EVENT.MESSAGE_REVOKED, (event) => {
      console.log('3、收到消息被撤回的通知');

      // 收到消息被撤回的通知
      // event.name - TIM.EVENT.MESSAGE_REVOKED
      // event.data - 存储 Message 对象的数组 - [Message] - 每个 Message 对象的 isRevoked 属性值为 true
    });

    this.tim.on(window.TIM.EVENT.CONVERSATION_LIST_UPDATED, (event) => {
      console.log('4、收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面', event.data);

      // 收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面
      // event.name - TIM.EVENT.CONVERSATION_LIST_UPDATED
      // event.data - 存储 Conversation 对象的数组 - [Conversation]
    });

    this.tim.on(window.TIM.EVENT.GROUP_LIST_UPDATED, (event) => {
      console.log('5、收到群组列表更新通知，可通过遍历 event.data 获取群组列表数据并渲染到页面', event.data);
      const { ims: { timIsGroupReady = false, timIsReady = false } = {} } = window.globalStore.getState();
      const { data = [], name = '' } = event;
      console.log('5、收到群组列表更新通知', timIsGroupReady, timIsReady);
      if (!timIsGroupReady && data.length && name === window.TIM.EVENT.GROUP_LIST_UPDATED) {
        window.globalStore.dispatch(timSdkDataDynamicUpdate({ timIsGroupReady: true }));
        if (timIsReady) {
          this.readyState = 1;
          window.globalStore.dispatch(timSdkGetGroupList({}));
        }
      }

      // 收到群组列表更新通知，可通过遍历 event.data 获取群组列表数据并渲染到页面
      // event.name - TIM.EVENT.GROUP_LIST_UPDATED
      // event.data - 存储 Group 对象的数组 - [Group]
    });

    this.tim.on(window.TIM.EVENT.GROUP_SYSTEM_NOTICE_RECEIVED, (event) => {
      console.log('6、收到新的群系统通知');
      // 收到新的群系统通知
      // event.name - TIM.EVENT.GROUP_SYSTEM_NOTICE_RECEIVED
      // event.data.type - 群系统通知的类型，详情请参见 GroupSystemNoticePayload 的 operationType 枚举值说明
      // event.data.message - Message 对象，可将 event.data.message.content 渲染到到页面
    });

    this.tim.on(window.TIM.EVENT.PROFILE_UPDATED, (event) => {
      console.log('7、收到自己或好友的资料变更通知');

      // 收到自己或好友的资料变更通知
      // event.name - TIM.EVENT.PROFILE_UPDATED
      // event.data - 存储 Profile 对象的数组 - [Profile]
    });

    this.tim.on(window.TIM.EVENT.BLACKLIST_UPDATED, (event) => {
      console.log('8、收到黑名单列表更新通知');

      // 收到黑名单列表更新通知
      // event.name - TIM.EVENT.BLACKLIST_UPDATED
      // event.data - 存储 userID 的数组 - [userID]
    });

    this.tim.on(window.TIM.EVENT.ERROR, (event) => {
      console.log('9、收到 SDK 发生错误通知，可以获取错误码和错误信息', event.data.message);
      return this.onError(event.name);
      // 收到 SDK 发生错误通知，可以获取错误码和错误信息
      // event.name - TIM.EVENT.ERROR
      // event.data.code - 错误码
      // event.data.message - 错误信息
    });

    this.tim.on(window.TIM.EVENT.SDK_NOT_READY, (event) => {
      console.log('10、收到 SDK 进入 not ready 状态通知，此时 SDK 无法正常工作');
      this.readyState = 3;
      return this.onReadyStateUpdate(event);
      // 收到 SDK 进入 not ready 状态通知，此时 SDK 无法正常工作
      // event.name - TIM.EVENT.SDK_NOT_READY
    });

    this.tim.on(window.TIM.EVENT.KICKED_OUT, (event) => {
      console.log('11、收到被踢下线通知');
      // 收到被踢下线通知
      // event.name - TIM.EVENT.KICKED_OUT
      // event.data.type - 被踢下线的原因，例如:
      //    - TIM.TYPES.KICKED_OUT_MULT_ACCOUNT 多实例登录被踢
      //    - TIM.TYPES.KICKED_OUT_MULT_DEVICE 多终端登录被踢
      //    - TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED 签名过期被踢 （v2.4.0起支持）。
      this.logout();
      this.readyState = 3;
      StaticToast.error('你已被踢下线');
    });

    this.tim.on(window.TIM.EVENT.NET_STATE_CHANGE, (event) => {
      console.log('12、网络状态发生改变（v2.5.0 起支持）', event);
      //  网络状态发生改变（v2.5.0 起支持）。
      // event.name - TIM.EVENT.NET_STATE_CHANGE
      // event.data.state 当前网络状态，枚举值及说明如下：
      //     \- TIM.TYPES.NET_STATE_CONNECTED - 已接入网络
      //     \- TIM.TYPES.NET_STATE_CONNECTING - 连接中。很可能遇到网络抖动，SDK 在重试。接入侧可根据此状态提示“当前网络不稳定”或“连接中”
      //    \- TIM.TYPES.NET_STATE_DISCONNECTED - 未接入网络。接入侧可根据此状态提示“当前网络不可用”。SDK 仍会继续重试，若用户网络恢复，SDK 会自动同步消息
    });
    this.login(options);
  }
  onReadyStateUpdate({ name }) {
    const isSDKReady = name === window.TIM.EVENT.SDK_READY;
    console.log('~~~--isSDKReady---', name, isSDKReady);
    window.globalStore.dispatch(timSdkDataDynamicUpdate({ timIsReady: isSDKReady }));
    if (isSDKReady) {
      const { ims: { timIsGroupReady = false } = {} } = window.globalStore.getState();
      if (timIsGroupReady) {
        this.readyState = 1;
        window.globalStore.dispatch(timSdkGetGroupList({}));
      }
      this.tim.getMyProfile().then((res) => {
        const { code = '', data = {} } = res;
        if (code === 0) {
          window.globalStore.dispatch(timSdkDataDynamicUpdate({ userInfo: { ...data, username: data.userID } }));
        }
      });
    }
  }
  onError(event) {
    console.log('SDK ERROR~', event);
    const { data: { message = '', code = '' } = {} } = event;
    if (message && code && code !== 2800 && code !== 2999) {
      StaticToast.error(message || '服务异常');
      this.readyState = 3;
    }
  }
  onWatchTimEndEvent(data = []) {
    data.map((item) => {
      const { cloudCustomData = '{}' } = item;
      // if (type === 'TIMCustomElem') {
      const { customEvent = '' } = timCustomData(cloudCustomData);
      if (customEvent == 'CMD_010') {
        // inquiryStatus: 4, 不再更新状态，仅更新前端输入框的展示
        window.globalStore.dispatch(pushIMInquiryEndNoticeOrOther({ fakeInquiryStatus: 4 }));
      }
      // }
      return item;
    });
  }
  logout() {
    try {
      window.globalStore.dispatch(timSdkLogout());
      this.tim.logout && this.tim.logout();
      this.readyState = 0;
    } catch (error) {}
  }
}

export default new TIMSDKIM();
